import { DestructuredURL, DVString } from './shared';
import { LocalBadgeLocale } from '@amzn/dvui/dist/MaturityRating'

export interface Infobox {
    message: DVString
    type?: string
}

export interface CustomerReviews {
    value?: number
    count?: number
    countFormatted?: string
    link?: string
}

export interface HoverMessages {
    infoboxes?: Infobox[]
    offers?: DVString[]
}

export interface HideThisOutput {
    success: boolean
    message: string
    manageLink?: TextLink
    hideThisAction?: HideThisAction
    tellUsWhyAction?: TellUsWhyAction
}

export interface TextLink {
    text: string
    href: string
}

export interface HideThisAction {
    tag: HideThisTag;
    text: string;
    endpoint: DestructuredURL;
    hasTimer?: boolean
}

export enum HideThisTag {
    HIDE = "Hide",
    UNHIDE = "Unhide"
}

export interface TellUsWhyAction {
    text: string
    options: TellUsWhyOption[]
}

export interface TellUsWhyOption {
    text: string
    endpoint: DestructuredURL
}

export interface TellUsWhyOutput {
    message: string
}


export interface MaturityRatingProps {
    rating: string
    locale?: LocalBadgeLocale
    small?: boolean
    title?: string
    link?: DVString
}
